module.exports = __webpack_public_path__ + "static/media/pending.1405c679.png";